export const DEFAULT_API_KEY = 'l7xx8785261b2a33457db88959a8679a1307'
